import React from "react";

interface NewsDetailSkeletonProps {
  isMobile?: boolean;
}

export const NewsDetailSkeleton: React.FC<NewsDetailSkeletonProps> = ({
  isMobile = false,
}) => {
  if (isMobile) {
    return (
      <div className="content-wrapper max-w-[1328px] mx-auto bg-white flex flex-col">
        <div className="relative w-[375px] h-[720px] py-3 px-4 gap-3 bg-white">
          <div className="w-[343px] h-[569px] gap-3 flex flex-col">
            {/* Image Skeleton */}
            <div className="w-[343px] h-[192px] bg-gray-200 animate-pulse rounded" />

            {/* Header Skeleton */}
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-gray-200 animate-pulse rounded-full" />
                <div className="w-24 h-4 bg-gray-200 animate-pulse rounded" />
                <div className="w-20 h-4 bg-gray-200 animate-pulse rounded ml-auto" />
              </div>
              <div className="w-full h-6 bg-gray-200 animate-pulse rounded" />
              <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded" />
              <div className="flex items-center gap-2">
                <div className="w-16 h-4 bg-gray-200 animate-pulse rounded" />
                <div className="w-12 h-4 bg-gray-200 animate-pulse rounded" />
              </div>
            </div>

            {/* Content Skeleton */}
            <div className="w-[343px] h-[240px] gap-3 flex flex-col">
              <div className="w-full h-4 bg-gray-200 animate-pulse rounded" />
              <div className="w-full h-4 bg-gray-200 animate-pulse rounded" />
              <div className="w-5/6 h-4 bg-gray-200 animate-pulse rounded" />
              <div className="w-full h-4 bg-gray-200 animate-pulse rounded" />
              <div className="w-4/5 h-4 bg-gray-200 animate-pulse rounded" />
              <div className="w-full h-4 bg-gray-200 animate-pulse rounded" />
              <div className="w-3/4 h-4 bg-gray-200 animate-pulse rounded" />
            </div>

            {/* Banner Skeleton */}
            <div className="w-full h-12 bg-gray-200 animate-pulse rounded" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-[590px] w-[1440px] gap-[2px] px-6 bg-[#F2F4FB]">
      <div className="relative bg-white w-[1392px] h-[590px] gap-3 p-4">
        <div className="flex flex-col w-[698px] h-[558px] gap-3">
          {/* Image Skeleton */}
          <div className="w-[698px] h-[392px] bg-gray-200 animate-pulse rounded" />

          {/* Header Skeleton */}
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gray-200 animate-pulse rounded-full" />
              <div className="w-32 h-5 bg-gray-200 animate-pulse rounded" />
              <div className="w-24 h-5 bg-gray-200 animate-pulse rounded ml-auto" />
            </div>
            <div className="w-full h-7 bg-gray-200 animate-pulse rounded" />
            <div className="w-4/5 h-7 bg-gray-200 animate-pulse rounded" />
            <div className="flex items-center gap-2">
              <div className="w-20 h-5 bg-gray-200 animate-pulse rounded" />
              <div className="w-16 h-5 bg-gray-200 animate-pulse rounded" />
            </div>
          </div>

          {/* Content Skeleton */}
          <div className="w-[698px] h-[144px] gap-1 flex flex-col">
            <div className="w-full h-6 bg-gray-200 animate-pulse rounded" />
            <div className="w-full h-6 bg-gray-200 animate-pulse rounded" />
            <div className="w-5/6 h-6 bg-gray-200 animate-pulse rounded" />
            <div className="w-full h-6 bg-gray-200 animate-pulse rounded" />
            <div className="w-4/5 h-6 bg-gray-200 animate-pulse rounded" />
          </div>

          {/* Banner Skeleton */}
          <div className="w-full h-16 bg-gray-200 animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
};

